import { Timestamp } from "firebase/firestore/lite";

export interface DbBusinessWhatsappCustomHeader {
  bsp_type: BSPType;
  app_id: string | null;
  app_name: string | null;
  waba_id: string | null;
  phone: string;
  country_code: string;
  display_name: string;
  contact_name: string;
  contact_phone: string;
  contact_country_code: string;
  contact_email: string;
  payment_id: string | null;
  embedded_signup_link: string | null;
  embedded_signup_status: EmbeddedSignupStatus | null;
  is_registered: boolean;
  is_verified: boolean;
  created_at: Timestamp | null;
  updated_at: Timestamp | null;
  deleted_at: Timestamp | null;
}

export enum BSPType {
  Gupshup = "gupshup",
}

export enum EmbeddedSignupStatus {
  Pending = "pending",
  Completed = "completed",
}

export interface ValidationError {
  for: string;
  message: string;
}

export const whatsappHeaderType = {
  CANBOOK: "canbook",
  CUSTOM: "custom",
};
